import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Skeletons } from '../Skeletons';

interface SeparatorAuthMethodsProps {
  isLoading: boolean;
}

export const SeparatorAuthMethods: FC<SeparatorAuthMethodsProps> = ({ isLoading }) => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full items-center">
      {isLoading ? (
        <>
          <Skeletons className="h-[1px] flex-1" />
          <Skeletons className="h-[14px] mx-2 w-5" />
          <Skeletons className="h-[1px] flex-1" />
        </>
      ) : (
        <>
          <span className="h-[1px] w-full bg-sum_alternative_auth_text" />
          <p className="text-sm font-medium text-sum_alternative_auth_text mx-2">
            {t('general.or')}
          </p>
          <span className="h-[1px] w-full bg-sum_alternative_auth_text" />
        </>
      )}
    </div>
  );
};
